import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { breakpoints } from "../../../../core/application/theme/breakpoints"
import DeleteImageIcon from "../../../icons/DeleteImageIcon"

export interface IPhotoItemProps {
    file: File,
    onDeletePhoto: () => void
}

const PhotoItem: React.FC<IPhotoItemProps> = ({
    file,
    onDeletePhoto
}) => {
    const [fileDataURL, setFileDataURL] = useState<string | null>(null)

    useEffect(() => {
        let isCancelled = false
        let fileReader: FileReader | undefined
        if (file) {
            fileReader = new FileReader()
            fileReader.onload = (e) => {
                if (e.target) {
                    const { result } = e.target;
                    if (result && !isCancelled && typeof(result) === 'string') {
                        setFileDataURL(result)
                    }
                }
            }
            fileReader.readAsDataURL(file);
        }
        return () => {
            isCancelled = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
        }
    }, [file])

    return (
        <PhotoItemContainer>
            {fileDataURL && (
                <>
                    <img src={fileDataURL} alt="preview" />
                    <DeleteButton onClick={onDeletePhoto}>
                        <DeleteImageIcon/>
                    </DeleteButton>
                </>
            )}
        </PhotoItemContainer>
    )
}

const PhotoItemContainer = styled.div`
    padding-top: 14px;
    padding-right: 14px;
    position: relative;
    & img {
        aspect-ratio: 1.5;
        object-fit: cover;
        object-position: center;
        border-radius: 8px;
        height: 100%;
    }
    display: inline-block;
    height: 90px;

    @media ${breakpoints.tablet} {
        height: 100%;
        & img {
            aspect-ratio: 1;
        }
    }
`

const DeleteButton = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
`

export default PhotoItem
